import axios from "axios";
import { AUTH_TOKEN } from "redux/constants/servicio-autenticacion/Auth";

const configuredBase = (process.env.REACT_APP_API_URL_LICENCIAS || "/licencias").replace(/\/$/, "");
export const licenseApi = axios.create({
  baseURL: `${configuredBase}/api`,
  timeout: 20000,
});

licenseApi.interceptors.request.use((request) => {
  const token = localStorage.getItem(AUTH_TOKEN);
  if (token) request.headers.Authorization = `Bearer ${token}`;
  return request;
});

export const errorMessage = (error) =>
  error?.response?.data?.error?.message ||
  error?.response?.data?.message ||
  error?.message ||
  "No se pudo completar la operación";

const api = {
  dashboard: () => licenseApi.get("/dashboard").then(({ data }) => data),
  inventory: (params) => licenseApi.get("/inventory", { params }).then(({ data }) => data),
  contract: (id) => licenseApi.get(`/license-contracts/${id}`).then(({ data }) => data),
  audit: (id) => licenseApi.get(`/license-contracts/${id}/audit-log`).then(({ data }) => data),
  createContract: (body) => licenseApi.post("/license-contracts", body).then(({ data }) => data),
  createPeriod: (contractId, body) =>
    licenseApi.post(`/license-contracts/${contractId}/periods`, body).then(({ data }) => data),
  activatePeriod: (periodId) =>
    licenseApi.post(`/license-periods/${periodId}/activate`).then(({ data }) => data),
  addAssignment: (periodId, body) =>
    licenseApi.post(`/license-periods/${periodId}/assignments`, body).then(({ data }) => data),
  setAllocations: (periodId, allocations) =>
    licenseApi.put(`/license-periods/${periodId}/cost-allocations`, { allocations }).then(({ data }) => data),
  declarations: () => licenseApi.get("/usage-declarations/pending").then(({ data }) => data),
  submitDeclaration: (id, decision, comment) =>
    licenseApi.post(`/usage-declarations/${id}/submit`, { decision, comment }).then(({ data }) => data),
  approvals: () => licenseApi.get("/renewal-approvals/pending").then(({ data }) => data),
  decideApproval: (id, decision, comment) =>
    licenseApi.post(`/renewal-approvals/${id}/${decision}`, { comment }).then(({ data }) => data),
  cancellations: () => licenseApi.get("/cancellation-tasks").then(({ data }) => data),
  startCancellation: (id) =>
    licenseApi.post(`/cancellation-tasks/${id}/start`).then(({ data }) => data),
  confirmCancellation: (id, comment) =>
    licenseApi.post(`/cancellation-tasks/${id}/confirm`, { comment }).then(({ data }) => data),
  users: () => licenseApi.get("/catalogs/users").then(({ data }) => data),
  departments: () => licenseApi.get("/catalogs/departments").then(({ data }) => data),
  costCenters: () => licenseApi.get("/catalogs/cost-centers").then(({ data }) => data),
  notifications: () => licenseApi.get("/notifications").then(({ data }) => data),
  readNotification: (id) => licenseApi.post(`/notifications/${id}/read`),
  readAllNotifications: () => licenseApi.post("/notifications/read-all"),
};

export default api;
